import { trpc } from "../../lib/trpc";
import { Loader2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";

export function OrgAdminUnitsPage() {
  const { data: units, isLoading } = trpc.buildings.listUnits.useQuery();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Units</h1>
          <p className="text-muted-foreground">
            View all units in your organization's buildings.
          </p>
        </div>
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Unit No</TableHead>
              <TableHead>Building</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Sale Status</TableHead>
              <TableHead>Repair Status</TableHead>
              <TableHead>Net Area</TableHead>
              <TableHead>Gross Area</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {units?.map((unit: any) => (
              <TableRow key={unit.id}>
                <TableCell className="font-medium">{unit.unit_no}</TableCell>
                <TableCell>{unit.buildings?.name} ({unit.buildings?.code})</TableCell>
                <TableCell>{unit.unit_type || "-"}</TableCell>
                <TableCell>
                  <Badge variant="outline">{unit.sale_status || "Unknown"}</Badge>
                </TableCell>
                <TableCell>
                  <Badge variant="secondary">{unit.repair_status || "Unknown"}</Badge>
                </TableCell>
                <TableCell>{unit.area_net_sqm ? `${unit.area_net_sqm} m²` : "-"}</TableCell>
                <TableCell>{unit.area_gross_sqm ? `${unit.area_gross_sqm} m²` : "-"}</TableCell>
              </TableRow>
            ))}
            {(!units || units.length === 0) && (
              <TableRow>
                <TableCell colSpan={7} className="text-center h-24">
                  No units found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
